import { DateTime } from 'luxon';

export class CustomerCommissionBillInfo {
    public readonly year: string;

    constructor(json: Record<string, any>) {
        this.year = json.year;
    }
}

export class CustomerCommissionBill {
    public readonly invoiceDate: DateTime;

    public readonly overviewResourceUrl?: string;

    public readonly detailResourceUrl?: string;

    constructor(json: Record<string, any>) {
        this.invoiceDate = DateTime.fromISO(json.invoiceDate);
        this.overviewResourceUrl = json.overviewResourceUrl;
        this.detailResourceUrl = json.detailResourceUrl;
    }
}
